import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

const Navigation = ({ 
  currentSection, 
  totalSections, 
  readSections, 
  onPrevious, 
  onMarkComplete,
  onContinue 
}) => {
  const isCompleted = readSections.includes(currentSection);
  const isLastSection = currentSection === totalSections - 1;
  
  return (
    <div className="flex justify-between items-center mt-6">
      <button
        onClick={onPrevious}
        disabled={currentSection === 0}
        className={`flex items-center space-x-2 px-4 py-2 rounded-lg ${
          currentSection === 0
            ? 'opacity-50 cursor-not-allowed'
            : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
        }`}
      >
        <ChevronLeftIcon className="w-5 h-5" />
        <span>Previous</span>
      </button>

      <div className="flex space-x-2">
        <button
          onClick={onMarkComplete}
          className={`px-4 py-2 rounded-lg ${
            isCompleted
              ? 'bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300'
              : 'bg-green-500 hover:bg-green-600 text-white'
          }`}
        >
          {isCompleted ? 'Unmark Complete' : 'Mark Complete'}
        </button>

        {!isLastSection && (
          <button
            onClick={onContinue}
            className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg flex items-center space-x-2"
          >
            <span>Continue</span>
            <ChevronRightIcon className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  );
};

export default Navigation;
